import AssessmentFlowComponent from 'components/assessment-flow';
import { useHistory } from 'react-router-dom';
import { BIPOLAR } from 'components/shared/types';
import { BIPOLAR_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const BipolarAssessment = () => {
  const history = useHistory();
  const handleNextPage = () => {
    history.push('/bipolar-assessment-email');
  };

  return (
    <AssessmentFlowComponent
      serviceLine={BIPOLAR}
      handleNextPage={handleNextPage}
      storageKey={BIPOLAR_ASSESSMENT_RESULT}
    />
  );
};

export default BipolarAssessment;
